export default function MinimumDepartmentResourcesController(
  $q,
  $scope,
  bcpDataService,
  editDepartmentResourceDialog,
  loaderService,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleExpandDepartmentResources = _handleExpandDepartmentResources;
  vm.handleEditDepartmentResources = _handleEditDepartmentResources;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _initEventListeners();
    _initPermissions();
    dfdActivate.resolve();
  }

  function _initPermissions() {
    vm.canExpand = vm.status !== 'No Department Resources Added';
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshBCPDepartmentResources',
      _refreshDepartmentResources
    );
  }

  function _handleExpandDepartmentResources() {
    if (!vm.hasData) {
      return _refreshDepartmentResources().then(() => {
        vm.hasData = true;
      });
    }
    return Promise.resolve();
  }

  function _refreshDepartmentResources() {
    const dfdRefresh = $q.defer();
    loaderService.showViewLoader = true;
    bcpDataService.getDepartments(vm.assessmentId).then((response) => {
      vm.departmentResources = response.data.result;
      loaderService.showViewLoader = false;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _handleEditDepartmentResources($event) {
    loaderService.showViewLoader = true;
    _refreshDepartmentResources().then(() => {
      ssDialogService.dialogs.bcp.editDepartmentResourceDialog = ssDialogService.alert(
        editDepartmentResourceDialog.getOptions($event, {
          departmentResources: vm.departmentResources,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.editDepartmentResourceDialog);
    });
  }
}

MinimumDepartmentResourcesController.$inject = [
  '$q',
  '$scope',
  'bcpDataService',
  'editDepartmentResourceDialog',
  'loaderService',
  'ssDialogService',
  'userService'
];
